// extracted by mini-css-extract-plugin
export default {"general":"collections_general__p-2bL","container":"collections_container__xIMkD"};